export const DATOFISCAL_PAIS = "MEXICO";
export const DATOFISCAL_ESTADO = "YUCATAN";
export const DATOFISCAL_MUNICIPIO = "MERIDA";

export const DATOFISCAL_CALLE = "63";
export const DATOFISCAL_COLONIA = "MERIDA CENTRO";
export const DATOFISCAL_CODIGOPOSTAL = "97000";
export const DATOFISCAL_NUMEROEXTERIOR = "474";

export const DATOFISCAL_REGIMENFISCAL = "11";
export const DATOFISCAL_USOCFDI = "22";

export const NO_FISCALES  = [3, 18, 5, 7, 8, 10, 21, 11];

export const SOCIEDADES_MERCANTILES = [
    'S.C.', 'S. EN C.', 'S. EN C. POR A', 'S. DE R. L. DE C.V.', 'S.A.',
    'S.A. DE C.V.', 'S.A.S.', 'S.A.P.I.', 'S.A.P.I. DE C.V.', 'A.C.', 'S.C.P.',
];